import React from 'react';
import { object, string, func } from 'prop-types';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';

const CheckoutCta = ({ className, price, onClick = noop }, { general }) => {
    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;

    return (
        <Button className={className}
            onClick={onClick}
            type="submit"
            color={btnColor}>
            <I18n k={'gig_page_perseus.packages.continue'}/>
            <span> ({price})</span>
        </Button>
    );
};

CheckoutCta.propTypes = {
    className: string,
    price: string,
    onClick: func
};

CheckoutCta.contextTypes = {
    general: object
};

export default CheckoutCta;
